export default "__VITE_ASSET__23161e3a__"